// Plan A no longer accepts new sign-ups (TASK-14124). Old entry links still
// carry `planType=A`, and the sign-up flow reads that value straight from the
// URL hash, so the router rewrites it to Plan T before any view sees it.
// Only the /sign/* routes are rewritten: once signed in, App.vue mirrors the
// account type into `planType`, and Connections (plus the business links it
// shares) reads it from the URL, so existing Plan A accounts must keep `A`.
// A repeated param (`?planType=A&planType=A`) arrives as an array and the hash
// reader would still pick up the first `A`, so arrays are checked too.
// Returns the same object when nothing changes so the caller can compare by
// reference and avoid a redirect loop.
export const normalizeSignupQuery = (query = {}) =>
    [].concat(query.planType).includes('A')
        ? { ...query, planType: 'T' }
        : query;

export const isSignRoute = (path = '') =>
    path === '/sign' || path.startsWith('/sign/');
